import {
  Action,
  AnyAction,
  configureStore,
  Reducer,
  ThunkAction,
} from '@reduxjs/toolkit'
import extraMiddleware from './middleware'
import appReducer from './reducers'
//import { preloadState } from "./state-persistance";

export const RESET_ACTION: AnyAction = {
  type: 'RESET',
}

const rootReducer: Reducer<RootState, AnyAction> = (state, action) => {
  if (action.type === 'RESET') {
    if (!state) return appReducer(state, action)
    const resetState = Object.keys(state as object).reduce((acc, key) => {
      ;(acc as Record<string, unknown>)[key] = undefined
      return acc
    }, {} as RootState)
    return appReducer(resetState, action)
  }

  return appReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  //preloadedState: preloadState(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(extraMiddleware),
})

export type RootState = ReturnType<typeof appReducer>
export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export default store
